import { useMemo } from 'react';
import { useStyles } from '@wix/tpa-settings/react';
import {
  createStylesParam,
  StyleParamType,
  wixColorParam,
} from '@wix/tpa-settings';

export function useHighLightColor() {
  const styles = useStyles();

  return useMemo(
    () =>
      styles.get(
        createStylesParam('feed-item-highlight-color', {
          type: StyleParamType.Color,
          getDefaultValue: wixColorParam(`color-8`, 0.3),
        }),
      ),
    [],
  );
}

export function useHighlight(highlightedText: string | undefined | null) {
  const preview = useMemo(() => {
    if (!highlightedText) {
      return '';
    }

    const [html] =
      highlightedText?.match(
        /(?:(?:\S+\s+){0,20})<em>[^<]+<\/em>(?:\s+\S+){0,20}/u,
      ) ?? [];

    // - (?:(?:\S+\s+){0,20}) - Matches up to 20 words before <em>, each word followed by whitespace
    // - <em>[^<]+<\/em> - Matches <em> tag content, ensuring no nested tags
    // - (?:\s+\S+){0,20} - Matches up to 20 words after <em>, each word preceded by whitespace

    const truncatedAfter = !highlightedText?.endsWith(html!);
    const truncatedBefore = !highlightedText?.startsWith(html!);

    return [truncatedBefore && '...', html, truncatedAfter && '...']
      .filter(Boolean)
      .join('');
  }, [highlightedText]);

  const total = useMemo(() => {
    return highlightedText?.match(/<em>/g)?.length ?? 0;
  }, [highlightedText]);

  const count = useMemo(() => {
    return preview?.match(/<em>/g)?.length ?? 0;
  }, [preview]);

  return { preview, total, count };
}

export function truncate(str: string, n: number) {
  return str.length > n ? str.slice(0, n - 1) + '&hellip;' : str;
}
